import { useTranslation } from 'react-i18next';
import { Box, Typography, useTheme } from '@mui/material';
import { tokens } from '../../global/theme/tokens';
import NoPhotographyOutlinedIcon from '@mui/icons-material/NoPhotographyOutlined';
import CommentsDisabledOutlinedIcon from '@mui/icons-material/CommentsDisabledOutlined';
import TimerOffOutlinedIcon from '@mui/icons-material/TimerOffOutlined';

export const TimeTrackingWarningEnumToLabel = ({ warning }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const enumMap = {
    MISSING_CLOCKOUT_IMAGE: {
      label: t('Missing clock-out photo'),
      color: colors.warning,
      Icon: NoPhotographyOutlinedIcon,
    },
    MISSING_COMMENT: {
      label: t('Missing clock-out comment'),
      color: colors.warning,
      Icon: CommentsDisabledOutlinedIcon,
    },
    AUTO_CLOCKOUT: {
      label: t('Automatic clock-out'),
      color: colors.error,
      Icon: TimerOffOutlinedIcon,
    },
  };

  const entry = enumMap[warning];
  if (!entry) return null;

  const { label, color, Icon } = entry;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color }}>
      <Icon fontSize="small" />
      <Typography variant="body2">{label}</Typography>
    </Box>
  );
};
